import { ChangeDetectorRef, Component, ContentChild, EventEmitter, HostBinding, Input, OnInit, Output, signal, Signal, SimpleChanges, TemplateRef, viewChild, ViewChild, WritableSignal } from '@angular/core';
import { Table } from 'primeng/table';
import { convertItems, FilterCondition, inputType, metadatetree, newmetadate, style } from './domain/datatable-domain';
import { FilterMatchMode, FilterMetadata, FilterService, MenuItem, MessageService, SortEvent } from 'primeng/api';
import { UtilService } from 'src/app/services/util.service';
import { FormControl, FormGroup } from '@angular/forms';
import { Menu } from 'primeng/menu';
import { ContextMenu } from 'primeng/contextmenu';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DialogTableComponent } from 'src/app/dialog-table/dialog-table.component';
import { ConfirmationService } from 'primeng/api';
import { DialogDetalleComponent } from '../dialog-detalle/dialog-detalle.component';
import { listarOpcionesTablaRequest, transaccionOpcionesTablaRequest } from 'src/app/roles/domain/request/rol_request';
import { StorageService } from 'src/app/services/storage.service';
import { RolRepository } from 'src/app/roles/domain/rol.repository';
import { Router } from '@angular/router';
import { ReportesRepository } from 'src/app/repositorio/reportes.repository';
import { ConfirmDeleteRowEvent } from 'src/app/interfaces/datatable.interface';
// import { Router } from '@angular/router';

@Component({
  selector: 'app-datatable',
  templateUrl: './datatable.component.html',
  styleUrls: ['./datatable.component.css'],
  providers: [DynamicDialogRef, MessageService],
  standalone: false
})
export class DatatableComponent implements OnInit {

  @ViewChild('dt1') table: Table

  // @viewChild ('editorRef') editorevent:any;
  @Input() id: string;
  @Input() dataTable: any[];
  @Input() defaultRow: any;
  @Input() title: string = ''
  @Input() metadataTable: newmetadate[] = [];
  @Input() metadataTableTree: metadatetree[] = [];
  @Input() filter: boolean = true;
  @Input() modeSelected: boolean = false;
  @Input() selectedRowInput: any;                       // valor que viene del padre
  @Output() selectedRowInputChange = new EventEmitter<any>(); // notificar al padre
  @Input() showSort: boolean = true;

  onSelectRow(row: any) {
    if (!this.modeSelected) return
    this.selectedRowInput = row;
    this.selectedRowInputChange.emit(row);
  }

  @Input() sortable: boolean = true;
  footer: boolean = false; //Pasar a variable publica
  @Input() filterGlobal: boolean = false;
  @Input() precarga: boolean = false;
  @Input() caption: boolean = false;
  @Input() paginacion: boolean = true;
  @Input() addRow: boolean = false;
  @Input() colorBtnMas: boolean = false;
  @Input() numFilasAdd: boolean = false;
  @Input() rowEdit: boolean = false;
  @Input() colorBtnEdit: boolean = false;
  @Input() btnEditAdelante: boolean = false;
  @Input() rowDelete: boolean = false;
  @Input() colorBtnDel: boolean = false;
  @Input() style: style;
  @Input() rows: any[] = [30, 50, 70]
  @Input() contextMenu: MenuItem[]
  @Input() rowDialog: boolean = false
  @Input() dialogItems: string[] = []
  @Input() preload: boolean = false
  @Input() exportData: boolean = false
  @Input() exportDataCsv: boolean = false
  @Input() exportFileName: string | null = null
  @Input() scrollHeight: string = '460px'
  @Input() blockedColumns: string[] = [];
  @Output() checkboxChange = new EventEmitter<{ rowIndex: number, isChecked: boolean, rowdata: any }>();
  @Input() customButtons: { icon?: string; function?: () => void; toolTip?: string; loading?: boolean; text?: string; disabled?: boolean }[] = [];
  @Output() rowAdded = new EventEmitter<any>();
  @Output() rowDeleted = new EventEmitter<any>();
  @Output() rowInitAdded = new EventEmitter<any>();
  @Input() modifiedRow: any;
  @Output() onDpChangeEvento = new EventEmitter<any>();
  @Input() onDpValueChangeEvento: EventEmitter<any>;
  @Output() onInputChangeEvento = new EventEmitter<any>();
  @Input() loading: boolean = false;
  @Input() reemplazarDataInput: any[] = [];
  metadataTableCopy: newmetadate[] = [];
  numfilaseditables: number = 1;
  form: FormGroup
  @Input() listaDatosPreCargadosAntesDeAgregar: any;//Es para que al agregar filas ya tengan datos prepuestos
  @Input() keepDPabierto: boolean = false;
  @Input() resaltarCabecera: boolean = false;
  @HostBinding('class.cabecera-resaltada') get aplicarClaseCabecera() { return this.resaltarCabecera; }
  @Input() btnResetFiltros: boolean = false;
  @Input() lineasTabla: boolean = false;
  @HostBinding('class.lineas-tabla-activa') get lineasTablaClass() { return this.lineasTabla; }
  @Input() ajustarTitulos: boolean = false;
  @HostBinding('class.ajustar-titulos') get ajustarTitulosClass() { return this.ajustarTitulos; }
  @Input() requireConfirmAddRow: boolean = false;
  @Output() confirmAddRow = new EventEmitter<(continuar: boolean) => void>();
  @Input() requireConfirmDeleteRow: boolean = false;
  @Output() confirmDeleteRow = new EventEmitter<ConfirmDeleteRowEvent>();
  @Input() disableAddRow: boolean = false;
  @Input() disableDeleteRow: boolean = false;
  @Input() editDisabled: boolean = false;
  @Input() btnDisabled: boolean = false;
  @Input() campoActivo: string | null = null;
  @Output() rowEditInit = new EventEmitter<any>();
  @Input() blockedColumnsEdit: string[] = [];
  @Input() customLeyendasHex: { color?: string; texto?: string }[] = []; @Input() blockedColumnsAdd: string[] = [];
  @Input() disableEditRow: boolean = false;

  @Output() addEmptyRowEvent = new EventEmitter<any>();
  @Input() styleRow: (row: any) => { [key: string]: string } = () => ({});
  @Input() cellStyleByField: { [field: string]: (row: any) => { [key: string]: string } } = {};
  @Input() onSaveEditFn: () => void
  @Output() saveEdit: EventEmitter<void> = new EventEmitter();
  @Output() cancelEdit: EventEmitter<void> = new EventEmitter();
  // @Input() function?: (row: any) => any

  //PARA MILTIPLES DATOS

  //PARA DATOS UNICOS DE LA TABLA
  @Input() key: string = ''

  @ContentChild('addHeaderStart', { static: true }) addHeaderStart!: TemplateRef<any>;
  @ContentChild('addBodyStart', { static: true }) addBodyStart!: TemplateRef<any>;
  @ContentChild('addHeaderEnd', { static: true }) addHeaderEnd!: TemplateRef<any>;
  @ContentChild('addBodyEnd', { static: true }) addBodyEnd!: TemplateRef<any>;
  @ContentChild('addHeaderTop', { static: true }) addHeaderTop!: TemplateRef<any>;
  @ContentChild('addLegend', { static: true }) addLegend!: TemplateRef<any>;

  @Output() Row = new EventEmitter<any>()
  onRowSelect(event) {
    this.Row.emit(event.data)
  }
  @Input() showFilters: boolean = false;
  cadenaFiltrosConsolidada: WritableSignal<string> = signal('');

  icon?: any;
  tooltip?: string;
  label?: string;
  //P-DIALOGS:
  visibleP_Dialog_General: boolean
  visibleDialog: boolean;
  visibleTextAreaEdit: boolean;
  visibleTextArea: boolean;
  visibleTextAreaParametros: boolean;
  tituloP1_Dialog: string;

  datoTextArea: string;
  mensajeDialog: any
  editing: boolean = false;
  rowModificado: boolean = true;

  // showDialog(row: any, title: string, field: string) {

  //   if (this.rowDialog) {
  //     this.visible = true
  //     this.mensajeDialog = { title: title, message: row[field] ? row[field] : 'NO SE ENCONTRARON ' + title.toUpperCase() }
  //   }

  // }
  funcionx: any;
  selectedRow: any; // Variable para guardar el row seleccionado
  // NUEVAS PROPIEDADES
  public validationErrors: { [key: string]: boolean } = {}; // Mapa para marcar visualmente las celdas
  public requiredFieldsMessage: string = ''; // Mensaje de error general

  private validateRow(product: any): boolean {
    let isValid = true;
    const requiredFields: string[] = [];
    this.validationErrors = {}; // Resetear errores visuales

    this.metadataTable.forEach(meta => {
      // Solo aplica a 'autocomplete' y 'text' con 'required: true'
      if ((meta.inputType === 'autocomplete' || meta.inputType === 'text') && meta.required) {
        const fieldValue = product[meta.field];
        let isFieldEmpty = false;

        if (meta.inputType === 'autocomplete') {
          // Para Autocomplete (p-select), el valor es un objeto {label, value} o null/undefined.
          // Se considera vacío si es null/undefined o si el objeto no tiene 'value'.

          if (!fieldValue) {
            isFieldEmpty = true;
          } else if (typeof fieldValue === 'object') {
            const valor = fieldValue.value;
            isFieldEmpty = valor === null || valor === undefined || String(valor).trim() === '';
          } else {
            isFieldEmpty = String(fieldValue).trim() === '';
          }

        } else if (meta.inputType === 'text') {
          // Para Text, se considera vacío si es null, undefined o una cadena vacía (después de trim).
          isFieldEmpty = !fieldValue || String(fieldValue).trim() === '';
        }

        if (isFieldEmpty) {
          isValid = false;
          requiredFields.push(meta.title); // Guardar el nombre de la columna para el mensaje
          this.validationErrors[meta.field] = true; // Marcar para pintado visual
        }
      }
    });

    if (!isValid) {
      this.requiredFieldsMessage = `Debe completar los campos obligatorios: ${requiredFields.join(', ')}`;
      // Usa un Toast/Message Service (como PrimeNG MessageService) aquí para mostrar this.requiredFieldsMessage
      this.messageService.add({ severity: 'error', summary: 'Error de Validación', detail: this.requiredFieldsMessage });
    } else {
      this.requiredFieldsMessage = '';
    }

    return isValid;
  }

  showDialog(row: any, title: string, field: string, modal: string, funcion: Function, dato: string) {

    this.visibleP_Dialog_General = true
    this.visibleDialog = true
    this.visibleTextAreaEdit = true;
    this.visibleTextArea = true;
    this.tituloP1_Dialog = title ?? ''
    if (modal === "dialog") {
      if (this.rowDialog) {
        this.visibleDialog = true;
        this.visibleTextAreaEdit = false;
        this.visibleTextArea = false;
        this.mensajeDialog = {
          title: title,
          message: row[field] ? row[field] : 'NO SE ENCONTRARON ' + title.toUpperCase()
        };
      }
    } else if (modal === "textAreaEdit") {

      this.visibleDialog = false;
      this.visibleTextAreaEdit = true;
      this.visibleTextArea = false;

      this.datoTextArea = dato;
      this.funcionx = funcion; // Guardar la función
      this.selectedRow = row; // Guardar el row seleccionado

    } else if (modal === "textArea") {

      this.visibleDialog = false;
      this.visibleTextAreaEdit = false;
      this.visibleTextArea = true;
      this.datoTextArea = dato;
      this.funcionx = funcion; // Guardar la función
      this.selectedRow = row; // Guardar el row seleccionado
    }
    else if (modal === "textAreaParametros") {

      this.visibleDialog = false;
      this.visibleTextAreaEdit = false;
      this.visibleTextArea = false;
      this.visibleTextAreaParametros = true;

      this.datoTextArea = dato;
      this.funcionx = funcion; // Guardar la función
      this.selectedRow = row; // Guardar el row seleccionado
    }

  }

  onConfirm() {
    if (this.funcionx && this.selectedRow) {
      this.funcionx({ event: {}, row: this.selectedRow, dato: this.datoTextArea });
    }
  }

  constructor(
    public readonly util: UtilService,
    public ref: DynamicDialogRef,
    private confirmationService: ConfirmationService,
    private readonly storage: StorageService,
    private readonly rol: RolRepository,
    private readonly servResportes: ReportesRepository,
    private readonly router: Router,
    private messageService: MessageService,
    private cdr: ChangeDetectorRef,
    private filterService: FilterService,
  ) {
    this.form = new FormGroup({
      filas: new FormControl(null, null)
    })

    const isBlank = (val: any) => val === undefined || val === null || val === '';

    // Contiene
    this.filterService.register(FilterMatchMode.CONTAINS, (value, filter): boolean => {
      if (isBlank(filter)) return true;
      if (isBlank(value)) return false;
      return value.toString().toLowerCase().includes(filter.toLowerCase());
    });

    // No contiene
    this.filterService.register(FilterMatchMode.NOT_CONTAINS, (value, filter): boolean => {
      if (isBlank(filter)) return true;
      if (isBlank(value)) return true;
      return !value.toString().toLowerCase().includes(filter.toLowerCase());
    });

    // Empieza con
    this.filterService.register(FilterMatchMode.STARTS_WITH, (value, filter): boolean => {
      if (isBlank(filter)) return true;
      if (isBlank(value)) return false;
      return value.toString().toLowerCase().startsWith(filter.toLowerCase());
    });

    // Termina con
    this.filterService.register(FilterMatchMode.ENDS_WITH, (value, filter): boolean => {
      if (isBlank(filter)) return true;
      if (isBlank(value)) return false;
      return value.toString().toLowerCase().endsWith(filter.toLowerCase());
    });

  }

  ngAfterContentInit() {

  }

  @ViewChild('menu') menu: Menu;
  @ViewChild('expmenu') expmenu: ContextMenu

  @Output() selectedRowData = new EventEmitter<any>()
  onRowRightClick(event: MouseEvent, rowdata: any) {
    event.preventDefault();
    this.selectedRowData.emit(rowdata);
  }

  selectedProduct: any;
  statuses: any[];
  activityValues: number[] = [0, 100];
  filtrosGlobal: any[] = []
  // key: string = ''
  JJ: string = ''
  styleHeader: { [key: string]: string } = {}
  styleBody: { [key: string]: string } = {}
  private nextKey: number = 1;//DANIEL200824}
  originalMetadataTable


  metadata: newmetadate[] = []
  data: any[] = []
  load: boolean = false
  ngOnChanges(changes: SimpleChanges): void {
    this.footer = false

    // // console.log("NUEVA METADATATABLE", this.metadataTable)
    if (!this.id && Array.isArray(this.metadataTable)) {
      this.metadata = [...this.metadataTable]//Estaba comentado, averiguar porque
      // // console.log("SI TIENE ID", this.metadata)
    }

    // this.metadata = this.metadataTable//Estaba comentado, averiguar porque

    // Verificamos si la propiedad 'metadataTable' ha cambiado
    if (changes['metadataTable']) {
      const nuevaMetadata = changes['metadataTable'].currentValue as newmetadate[];
      if (nuevaMetadata && nuevaMetadata.length > 0) {
        this.filtrosGlobal = nuevaMetadata.map(item => item.field);
        // // console.log('Filtros Globales actualizados mediante ngOnChanges:', this.filtrosGlobal);
      } else if (nuevaMetadata && nuevaMetadata.length === 0) {
        this.filtrosGlobal = [];
      }
    }

    // this.metadata = this.metadataTable
    const conversionList: convertItems[] = [
      { old: 'decimal', new: 'numeric' },
      { old: 'int', new: 'numeric' },
      { old: 'porcentaje', new: 'numeric' },
      { old: 'dropdown', new: 'text' },
      { old: 'text', new: 'text' },
      { old: 'icon', new: 'text' },
      { old: 'autocomplete', new: 'text' },
      { old: 'date', new: 'date' },
      { old: 'datetime', new: 'date' },
      { old: 'color', new: 'text' },
    ]

    function convertInputType(type?: inputType): string {
      if (!type) return '';
      const conversion = conversionList.find(r => r.old === type as inputType);
      return conversion ? conversion.new : '';
    }

    if (this.keepDPabierto === false && Array.isArray(this.metadata)) {
      this.metadata = this.metadata
        .filter(r => r && typeof r === 'object' && 'inputType' in r)
        .map(r => ({
          ...r,
          type: convertInputType(r.inputType)
        }));
    }

    this.load = this.preload

    if (this.load === true && this.dataTable.length === 0) {

      for (let index = 0; index < 5; index++) {
        const item = {}; // Crear un nuevo objeto vacío para cada iteración

        this.metadata?.forEach(r => {
          item[r.field] = null; // Agregar un campo al objeto con valor null (o vacío)
        });

        this.data.push(item); // Agregar el objeto al array 'data'
      }
    } else {
      this.data = this.dataTable
    }

    if (this.data?.length > this.rows[0] && this.paginacion == true) { this.footer = true }
    else if (this.paginacion === false) {
      this.footer = false;
      this.data = this.dataTable;
    }

    if (this.key === 'key') {
      this.data?.forEach(product => {
        if (!product.hasOwnProperty(this.key) || product[this.key] == null) {
          const existingKeys = this.data
            .map(r => parseInt(r[this.key], 10))
            .filter(num => !isNaN(num))
            .sort((a, b) => a - b);
          const nextKey = existingKeys.length > 0 ? Math.max(...existingKeys) + 1 : 1;

          product[this.key] = nextKey;
        }
      });
    }

    if (changes['reemplazarDataInput'] && this.reemplazarDataInput && this.reemplazarDataInput.length > 0) {
      this.reemplazarDataModoInput(this.reemplazarDataInput[0]);
    }

  }

  resetSort() {
    if (this.table) {
      this.table.sortField = null; // Elimina la columna ordenada
      this.table.sortOrder = 0; // Reinicia la dirección de ordenación
      this.table.reset(); // Resetea la tabla

      this.dataTable = Array.from(this.dataTable);
      this.notificarCambioFiltros();
    }
  }

  totales: boolean = false
  ngOnInit() {
    if (Array.isArray(this.metadataTable)) {
      this.metadataTable.forEach(r => {
        this.mainmetadata.push(r);
      });
    }
    // this.mainmetadata = this.metadataTable.slice()
    this.metadata = this.metadataTable
    // if (this.dataTable.length > 20) { this.footer = true }
    const conversionList: convertItems[] = [
      { old: 'decimal', new: 'numeric' },
      { old: 'int', new: 'numeric' },
      { old: 'porcentaje', new: 'numeric' },
      { old: 'dropdown', new: 'text' },
      { old: 'text', new: 'text' },
      { old: 'icon', new: 'text' },
      { old: 'autocomplete', new: 'text' },
      { old: 'date', new: 'date' },
      { old: 'datetime', new: 'date' },
      { old: 'color', new: 'text' }
    ]

    function convertInputType(type?: inputType): string {
      if (!type) return '';
      const conversion = conversionList.find(r => r.old === type as inputType);
      return conversion ? conversion.new : '';
    }

    if (this.keepDPabierto === false && Array.isArray(this.metadata)) {
      this.metadata = this.metadata
        .filter(r => r && typeof r === 'object' && 'inputType' in r)
        .map(r => ({
          ...r,
          type: convertInputType(r.inputType)
        }));
    }
    if (this.style) {
      if (this.style.header) {
        const r = this.style.header
        this.styleHeader = {};
        if (r.align) { this.styleHeader['text-align'] = r.align }
        if (r.size) { this.styleHeader['font-size'] = r.size }
        if (r.justify) { this.styleHeader['justify-content'] = r.justify }
      }
      if (this.style.body) {
        const r = this.style.body
        this.styleBody = {};
        if (r.align) { this.styleBody['text-align'] = r.align }
        if (r.size) { this.styleBody['font-size'] = r.size }
        if (r.justify) { this.styleBody['justify-content'] = r.justify }
      }
    }

    // if (this.data.length > 0) {
    //   this.loading = false
    //   const maxKey = Math.max(...this.data.map(row => parseInt(row[this.key], 10) || 0), this.nextKey);//DANIEL200824
    //   this.nextKey = maxKey + 1;
    // }

    this.metadata?.forEach(r => {
      if (r.rowFooter) {
        this.totales = true
      }
    })

    // this.caption = this.filterGlobal === true || this.addRow === true || this.title != '' ? true : false
    this.caption = this.filterGlobal === true || this.addRow === true || this.title != '' || this.customButtons.length != 0 ? true : false

    this.metadataTable?.forEach(r => {
      this.filtrosGlobal.push(r.field)

      const item = { field: r.field, header: r.title }
      this.cols.push(item)
    })
    this._selectedColumns = this.cols;

    this.onDpValueChangeEvento?.subscribe(event => {
      //// console.log("Evento recibido:", event);
      this.handleCambioValoresOnDPChange(event);
    });

    if (this.id) {
      const request = <listarOpcionesTablaRequest>{}
      request.usuario = this.storage.get('usuario')
      request.opcion = this.router.url
      request.tabla = this.id.toString().replace(/'/g, "")
      request.tab = ''
      this.rol.listarOpcionesTabla(request).subscribe(response => {

        if (response.datos.status === 200) {
          this._selectedColumns = []
          const valores = this.metadataTable.filter(r => response.datos.result.some(e => e.field === r.field))
          valores.forEach(x => {
            const item = { field: x.field, header: x.title }
            this._selectedColumns.push(item)
          })

          setTimeout(() => {
            this.metadata = this.metadataTable.filter(r =>
              response.datos.result.some(e => e.field === r.field)).sort((a, b) => {
                // Encuentra el índice de cada elemento en response.datos.result
                const indexA = response.datos.result.find(e => e.field === a.field)?.index ?? Infinity;
                const indexB = response.datos.result.find(e => e.field === b.field)?.index ?? Infinity;

                // Ordena según el índice de response.datos.result
                return indexA - indexB;
              })
            this.mainmetadata = this.mainmetadata.filter(r =>
              !this.metadata.some(e => e.field === r.field)
            );
          }, 0);



        }

      })

    }

    // this.originalMetadataTable = JSON.parse(JSON.stringify(this.metadataTable));
    if (this.metadataTable) {
      this.originalMetadataTable = JSON.parse(JSON.stringify(this.metadataTable));
    } else {
      this.originalMetadataTable = [];
    }

  }

  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = null;

      if (value1 == null && value2 != null) result = -1;
      else if (value1 != null && value2 == null) result = 1;
      else if (value1 == null && value2 == null) result = 0;
      else if (typeof value1 === 'string' && typeof value2 === 'string') result = value1.localeCompare(value2);
      else result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;

      return event.order * result;
    });
  }

  clonedProducts: { [s: string]: any } = {};
  editingNew: boolean = false

  // onRowEditInit(product: any) {
  //   this.clonedProducts[product[this.key]] = { ...product };
  //   this.initForm()
  //   setTimeout(() => {
  //     this.setValue(product)
  //   }, 0);
  // }

  // cambio maria
  // onRowEditInit(product: any) {
  //   this.metadataTableCopy = [...this.metadata];
  //   this.initForm()
  //   this.editing = true;

  //   this.clonedProducts[product[this.key]] = { ...product };

  //   this.metadataTable.forEach(item => {
  //     if (item.inputType === 'autocomplete' || item.inputType === 'dropdown') {
  //       // || item.inputType === 'text'
  //       if (item.dropdown && typeof this.clonedProducts[product[this.key]][item.field] === 'string') {
  //         const label = this.clonedProducts[product[this.key]][item.field];
  //         const selectedOption = item.dropdown.find(option => option.label === label);
  //         if (selectedOption) {
  //           this.clonedProducts[product[this.key]][item.field] = selectedOption;
  //         }
  //       }
  //     }
  //   });

  //   setTimeout(() => {
  //     if (this.group) {
  //       this.setValue(this.clonedProducts[product[this.key]]);
  //     } else {
  //       console.warn("El formulario no está inicializado.");
  //     }
  //   }, 0);
  // }

  acceptDisabled: boolean = false;
  public onRowEditInit(product: any) {
    this.metadataTableCopy = [...this.metadata];
    this.initForm();
    this.cdr.detectChanges();
    this.editing = true;
    const key = product[this.key];
    this.acceptDisabled = false;
    this.erroresValidacion = {};
    this.puedeValidar[key] = false;
    Object.keys(this.puedeValidar).forEach(k => this.puedeValidar[Number(k)] = false);
    // Realizamos una copia profunda para evitar que las filas compartan referencias
    this.clonedProducts[product[this.key]] = JSON.parse(JSON.stringify(product));

    // Procesar cada item de la metadataTable
    this.metadataTable.forEach(item => {
      if (item.inputType === 'autocomplete' || item.inputType === 'dropdown') {
        // Si el item tiene dropdown y es un string, encontrar el objeto correspondiente
        if (item.dropdown && typeof this.clonedProducts[product[this.key]][item.field] === 'string') {
          const label = this.clonedProducts[product[this.key]][item.field].trim();
          const selectedOption = item.dropdown.find(option => option.label.trim() === label);
          if (selectedOption) {
            this.clonedProducts[product[this.key]][item.field] = selectedOption;
          }
        }
      } else if (item.inputType === 'date') {
        const label = this.clonedProducts[product[this.key]][item.field];
        const dateFormat = label != null && label != '' ? new Date(label) : null;
        if (dateFormat) {
          this.clonedProducts[product[this.key]][item.field] = dateFormat;
        }
      }

      if (item.inputType === 'date') {
        const value = product[item.field];
        product[item.field] = value != null && value != '' ? new Date(value) : null;
      }
    });

    setTimeout(() => {
      if (this.group) {
        this.setValue(this.clonedProducts[product[this.key]]);
      } else {
        console.warn("El formulario no está inicializado.");
      }
    }, 0);
    this.rowEditInit.emit(product);
  }

  group: FormGroup
  initForm() {
    const controls = {};
    this.metadataTable.forEach(item => {
      controls[item.field] = new FormControl(null);
    });
    this.group = new FormGroup(controls);
  }

  // setValue(row) {
  //   this.metadataTable.forEach(item => {
  //     if (item.inputType == 'autocomplete' || item.inputType == 'dropdown') {
  //       if (item.dropdown) {
  //         var listaItem = row[item.field]
  //         // original this.group.get(item.field).setValue(item.dropdown.find(option => option.label === row[item.field]));
  //         // cambio miguel
  //         //
  //         this.group.get(item.field).setValue(item.dropdown.find(option => option.label === (listaItem.label == undefined ? listaItem : listaItem.label)).label);
  //       }
  //     }
  //     if (item.inputType == 'text' || item.inputType == 'int') {
  //       this.group.get(item.field).setValue(row[item.field]);
  //     }
  //   });
  // }

  // cambio maria
  setValue(row: any) {
    if (!this.group) {
      console.warn(`El formulario no está definido. No se puede establecer el valor.`);
      return;
    }
    this.metadataTable.forEach(item => {
      const control = this.group.get(item.field);
      if (!control) {
        console.warn(`El control para el campo ${item.field} no existe en el formulario y se omitirá.`);
      }
      const listaItem = row[item.field] !== undefined ? row[item.field] : null;
      let valueToSet = listaItem;

      if (item.inputType === 'autocomplete' || item.inputType === 'dropdown') {
        if (item.dropdown) {
          const selectedOption = item.dropdown?.find(option => option?.label === (typeof listaItem === 'object' ? listaItem?.label : listaItem));
          valueToSet = selectedOption || listaItem;
        }
      }
      if (item.inputType === 'date') {
        valueToSet = valueToSet != null && valueToSet != '' ? new Date(valueToSet) : null;
      }
      control.setValue(valueToSet);
    });
  }

  // cambio maria
  // onRowEditSave(product: any, index: number) {
  //   this.reestablecerMetadata();
  //   product.ESTADO_OBJ = (product.ESTADO_OBJ === "I" || product.ESTADO_OBJ === "D") ? product.ESTADO_OBJ : "U";
  //   this.editing = false;
  //   this.metadataTable.forEach(item => {
  //     if (item.inputType === 'autocomplete' || item.inputType === 'dropdown') {
  //       if (item.dropdown && typeof product[item.field] === 'string') {
  //         const label = product[item.field];
  //         const selectedOption = item.dropdown.find(option => option.label === label);
  //         if (selectedOption) {
  //           product[item.field] = selectedOption;
  //         }
  //       }
  //     }
  //   });

  //   setTimeout(() => {
  //     this.setValue(product);
  //     this.dataTable[index] = { ...product };
  //   }, 0);

  //   setTimeout(() => {
  //     this.table.editingRowKeys[product[this.key]] = false;
  //   }, 1000);

  //   delete this.clonedProducts[product[this.key]];
  //   this.rowAdded.emit(product);
  //   // console.log("this.data onRowEditSave", product)
  // }

  // onRowEditSave(product: any, index: number) {//version maria
  //   this.reestablecerMetadata();  // Reseteamos los metadatos

  //   // Establecer el estado correcto
  //   product.ESTADO_OBJ = (product.ESTADO_OBJ === "I" || product.ESTADO_OBJ === "D") ? product.ESTADO_OBJ : "U";
  //   this.editing = false;  // Terminamos la edición

  //   // Revisar los campos tipo 'autocomplete' o 'dropdown'
  //   this.metadataTable.forEach(item => {
  //     if (item.inputType === 'autocomplete' || item.inputType === 'dropdown') {
  //       if (item.dropdown && typeof product[item.field] === 'string') {
  //         const label = product[item.field];
  //         const selectedOption = item.dropdown.find(option => option.label === label);
  //         if (selectedOption) {
  //           product[item.field] = selectedOption;  // Actualizamos el producto con la opción seleccionada
  //         }
  //       }
  //     }
  //   });

  //   // Usamos un setTimeout para darle tiempo a Angular de procesar las ediciones
  //   setTimeout(() => {
  //     this.dataTable[index] = { ...this.dataTable[index], ...product };
  //     this.rowAdded.emit(product);
  //     this.table.editingRowKeys[product[this.key]] = false;
  //   }, 0);
  //   delete this.clonedProducts[product[this.key]];
  //   // console.log("this.data onRowEditSave", product);
  // }

  public onRowEditSave(product: any, index: number) {//Version Daniel
    this.isnewRowAdded = false
    // 1. **VALIDACIÓN CRÍTICA**
    if (!this.validateRow(product)) {
      // Si la validación falla, detenemos el guardado.
      // Es importante mantener el editingRowKeys[product[this.key]] = true
      // para que la fila siga en modo edición.
      return;
    }
    // Si llegamos aquí, la validación fue exitosa
    this.validationErrors = {}; // Limpiar errores
    // this.rowModificado = true;

    this.reestablecerMetadata();  // Reseteamos los metadatos
    // Establecer el estado correcto
    product.ESTADO_OBJ = (product.ESTADO_OBJ === "I" || product.ESTADO_OBJ === "D" || product.ESTADO_OBJ === "A") ? product.ESTADO_OBJ : "U";
    this.editing = false;  // Terminamos la edición

    // Revisar los campos tipo 'autocomplete' o 'dropdown'
    this.metadataTable.forEach(item => {
      if (item.inputType === 'autocomplete' || item.inputType === 'dropdown' || item.inputType === 'selectEdit') {
        if (item.dropdown && typeof product[item.field] === 'string') {
          const label = product[item.field];
          const selectedOption = item.dropdown.find(option => option.label.trim() === label.trim());
          if (selectedOption) {
            product[item.field] = selectedOption;  // Actualizamos el producto con la opción seleccionada
          }
        }
      }
      if (item.inputType === 'date') {
        const value = product[item.field];
        product[item.field] = value != null && value != '' ? new Date(value) : null;
      }
    });

    // this.dataTable[index] = { ...this.dataTable[index], ...product }; // se comenta por la demo de eliminar 11/06
    const key = this.key;
    const value = product[this.key];
    const indexdt = this.dataTable.findIndex(item => item[key] === value);
    if (indexdt === -1) {
      const length = this.dataTable.length;
      this.dataTable[length] = { ...this.dataTable[length], ...product }; // No existe, insertar al final
    } else {
      this.dataTable[indexdt] = { ...this.dataTable[indexdt], ...product }; // Ya existe, actualizarlo
    }

    // Emitimos el producto editado
    this.rowAdded.emit(product);
    // // console.log("this.dataTable onRowEditSave", this.dataTable); // descomentar para PRUEBAS
    // // console.log("this.data onRowEditSave", this.data); // descomentar para PRUEBAS
    this.table.editingRowKeys[product[this.key]] = false;// Solo deshabilitar si se guardó

    // Forzamos a Angular a detectar los cambios inmediatamente
    this.cdr.detectChanges();

    // Eliminamos el producto clonado
    this.saveEdit.emit(product);
    delete this.clonedProducts[product[this.key]];

  }

  onRowDeletePre(rowdata: any, index: number) {
    if (this.requireConfirmDeleteRow) {
      this.confirmDeleteRow.emit({
        row: rowdata,
        index: index,
        responder: (continuar: boolean) => {
          if (continuar) {
            this.onRowDelete(rowdata, index);
          }
        }
      });
    } else {
      this.onRowDelete(rowdata, index);
    }
  }

  onRowDelete(rowdata: any, index: number) {
    // 1. Obtener la clave de la fila a eliminar
    const rowKey = rowdata[this.key];

    // Si la fila estaba en edición, PrimeNG la considera activa.
    // Debemos eliminarla del mapa de edición.
    if (this.table && this.table.editingRowKeys && this.table.editingRowKeys[rowKey]) {
      delete this.table.editingRowKeys[rowKey];
    }
    this.rowDelete = true
    this.editing = false
    let wasInserted = rowdata?.ESTADO_OBJ === "I";
    this.data = this.data.filter(r => r[this.key] !== rowdata[this.key])

    const dtIndex = this.dataTable.findIndex(row =>
      JSON.stringify(row) === JSON.stringify(rowdata)
    );

    // // console.log("this.data onRowDelete luego de filter",this.data)
    if (!wasInserted) {
      rowdata.ESTADO_OBJ = "D"

      setTimeout(() => {
        this.setValue(rowdata);
        this.dataTable[dtIndex] = { ...rowdata };
      }, 1000);
    } else {
      // this.dataTable.splice(dtIndex, 1); //se comenta por que cuando es -1 elimina todo los registros.
      if (dtIndex >= 0) {
        this.dataTable.splice(dtIndex, 1);

      }
    }

    this.rowDeleted.emit(rowdata);
    // 3. Forzar la detección de cambios para actualizar el estado del botón de añadir
    this.cdr.detectChanges();
  }

  public onRowEditCancel(product: any, index: number) {
    this.isnewRowAdded = false;
    this.reestablecerMetadata();
    this.editing = false;
    this.data[index] = this.clonedProducts[product[this.key]]
    delete this.clonedProducts[product[this.key]]
    this.table.editingRowKeys[product[this.key]] = false;
    this.data = this.data.filter(r => r !== undefined && r !== null)
    this.cancelEdit.emit(product);
    this.erroresValidacion = {};
    this.cdr.detectChanges();
  }

  generateUniqueKey(): string {
    const maxKey = Math.max(
      ...this.data.map(row => parseInt(row[this.key], 10) || 0),
      0
    );
    return (maxKey + 1).toString();
  }
  // NUEVA FUNCIÓN PÚBLICA DE RESET
  public resetEditState(): void {
    // 1. Restablecer tu variable de control
    // this.rowModificado = true;

    // 2. Restablecer el estado interno de PrimeNG (si la referencia existe)
    if (this.table && this.table.editingRowKeys) {
      this.table.editingRowKeys = {}; // Limpia el mapa de claves en edición
    }

    // 3. Restablecer tu variable de control de edición de fila
    this.editing = false;

    // 4. (Opcional) Limpiar cualquier fila no deseada que haya quedado en 'data'
    // Si la última fila añadida no tiene una clave válida, es probable que haya que eliminarla
    // Esto dependerá de cómo manejas la adición, pero suele ser una buena práctica.
  }

  addEmptyRowPre() {
    // Verificar si alguna fila existente está en modo edición (la variable PrimeNG)
    const algunaFilaEditando = Object.keys(this.table.editingRowKeys).some(key => this.table.editingRowKeys[key] === true);
    if (algunaFilaEditando) {
      return
    }
    // this.rowModificado = false;

    if (this.requireConfirmAddRow) {
      this.confirmAddRow.emit((continuar: boolean, filaPreCargada?: any) => {
        if (continuar) {
          this.addEmptyRow(filaPreCargada);
        }
      });
    } else {
      this.addEmptyRow();
    }
  }

  isnewRowAdded: boolean = false;
  public addEmptyRow(ObjetoDatosPreCargados?: any) {
    this.isnewRowAdded = true;
    if (this.numFilasAdd == true) {

      this.ConfirmEditMasivo()
      let temporalDataTable = [...this.data];  // Crea una copia de los datos actuales

      for (let index = 0; index < this.numfilaseditables; index++) {

        this.rowEdit = true;
        this.initForm();

        let newRow: any;
        if (this.defaultRow) {
          newRow = { ...this.defaultRow };
        } else {
          newRow = {};
        }

        // Si hay datos en temporalDataTable
        if (temporalDataTable.length > 0) {
          const firstRow = temporalDataTable[0];

          // Recorremos las claves de la primera fila
          Object.keys(firstRow).forEach(key => {
            if (!(key in newRow)) {
              // Si el campo es nombrepuertoorigen o nombrepuertodestino, asignamos valores desde listaDatosPreCargadosAntesDeAgregar
              const matchingItem = this.listaDatosPreCargadosAntesDeAgregar.find(item => item[key]);
              if (matchingItem) {
                const { label, value } = matchingItem[key];
                newRow[key] = { label, value };
              } else {
                // Para otros campos, asignamos vacío por defecto
                newRow[key] = "";
              }
            }
          });

          const existingKeys = temporalDataTable
            .map(r => parseInt(r[this.key], 10))
            .filter(num => !isNaN(num))
            .sort((a, b) => a - b);

          let nextKey = existingKeys.length > 0 ? Math.max(...existingKeys) + (index + 1) : 1;
          newRow[this.key] = nextKey;
        } else {
          // Cuando temporalDataTable está vacío, usamos listaDatosPreCargadosAntesDeAgregar para asignar los valores dinámicamente

          // Verifica si listaDatosPreCargadosAntesDeAgregar tiene datos antes de usarla
          if (this.listaDatosPreCargadosAntesDeAgregar && this.listaDatosPreCargadosAntesDeAgregar.length > 0) {
            // Usamos listaDatosPreCargadosAntesDeAgregar para asignar los valores
            this.listaDatosPreCargadosAntesDeAgregar.forEach(item => {
              const field = Object.keys(item)[0];  // 'nombrepuertoorigen', 'nombrepuertodestino', etc.
              const { label, value } = item[field];  // Obtenemos label y value del objeto

              if (!(field in newRow)) {
                // Asignamos el objeto con el valor predeterminado a cada campo
                newRow[field] = { label, value };
              }
            });

            // Ahora asignamos una cadena vacía ("") a todos los campos que no estén presentes en newRow
            Object.keys(this.listaDatosPreCargadosAntesDeAgregar[0]).forEach(field => {
              if (!(field in newRow)) {
                newRow[field] = "";
              }
            });
          } else {
            // Si no hay datos en listaDatosPreCargadosAntesDeAgregar, asignamos campos vacíos por defecto
            // // console.log("No hay datos en listaDatosPreCargadosAntesDeAgregar");
            // Object.keys(this.metadata).forEach(field => {
            //   newRow[field] = "";
            // });
          }

          // Asignar un valor para this.key (el índice)
          newRow = { ...newRow, [this.key]: (index + 1) };
        }

        // Asignamos un valor por defecto para ESTADO_OBJ
        newRow.ESTADO_OBJ = "I";

        this.rowInitAdded.emit({ row: newRow, index: this.data.length });

        setTimeout(() => {
          if (this.modifiedRow) {
            newRow = this.modifiedRow;
          }

          // Añadir la nueva fila a temporalDataTable
          temporalDataTable = [...temporalDataTable, newRow];
          const ultimo = parseInt(newRow[this.key]);
          this.table.editingRowKeys[ultimo] = true;

          // Actualizar la tabla con los nuevos datos
          this.data = [...temporalDataTable];
        }, 1000);
      }
    } else {
      this.rowEdit = true
      this.initForm()

      let newRow: any;
      if (this.defaultRow) {
        newRow = { ...this.defaultRow };
      } else {
        newRow = {}
      }

      // if (this.data.length > 0) {
      if (this.dataTable.length > 0) {
        const firstRow = this.dataTable[0]//this.data[0];

        Object.keys(firstRow).forEach(key => {
          if (!(key in newRow)) {
            newRow[key] = '';
          }
        });

        const existingKeys = this.dataTable?.length == 0 ? this.data : this.dataTable
          .map(r => parseInt(r[this.key], 10))
          .filter(num => !isNaN(num))
          .sort((a, b) => a - b);
        let nextKey = existingKeys.length > 0 ? Math.max(...existingKeys) + 1 : 1; //comentado por que cuando es un solo elemento sale N/N
        if (nextKey?.toString() == 'NaN') {
          nextKey = 1
        }
        // const values = Array.isArray(existingKeys) ? existingKeys : [existingKeys];
        // let nextKey = values.length > 0 ? Math.max(...values) + 1 : 1;

        newRow[this.key] = nextKey;
      } else {
        newRow = { ...newRow, [this.key]: 1 };
      }

      newRow.ESTADO_OBJ = "I";

      if (ObjetoDatosPreCargados) {
        newRow = { ...newRow, ...ObjetoDatosPreCargados };
      }

      this.rowInitAdded.emit({ row: newRow, index: this.data.length });

      setTimeout(() => {
        if (this.modifiedRow) {
          newRow = this.modifiedRow;
        }
        this.data = [...this.data, newRow];
        const ultimo = parseInt(newRow[this.key]);
        this.table.editingRowKeys[ultimo] = true;
        this.addEmptyRowEvent.emit(newRow);
      }, 1000);
    }
  }

  convertToDecimal(value: any, decimalPlaces: number = 2): string {
    const numberValue = parseFloat(value);

    // Verifica si el valor es un número válido
    if (isNaN(numberValue)) return '0.00';

    // Usa toFixed para asegurarse de que el número tenga los decimales correctos
    const fixedNumber = numberValue.toFixed(decimalPlaces);

    // Usa una expresión regular para agregar separadores de miles
    const [integerPart, decimalPart] = fixedNumber.split('.');
    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // Devuelve el número con separadores de miles y los decimales
    return decimalPart ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart;
  }

  viewData() {
    // console.log('DATATABLE', this.dataTable)
    // console.log('PRECARGA', this.precarga)
    // console.log('KEY', this.key)
    // console.log('COLS', this.cols)
    // console.log('FILTRO GLOBAL', this.filtrosGlobal)
    // console.log('METADATATABLE', this.metadataTable)
    // console.log('CAPTION', this.caption)
    // console.log('TABLE PRIME', this.table)
    if (this.group) {
      // console.log('GROUP', this.group);
      // console.log('GROUP VALUE', this.group.value);
    }

  }

  // handleDropdownChange(field: string, children: string, event: any, dropdown) {
  //   if (this.onDpChangeEvento && this.onDpChangeEvento.closed === false) {
  //     this.metadataTableCopy = [...this.metadata];
  //     this.onDpChangeEvento.emit({ field, event });
  //     this.metadata = this.metadataTable.map(row => { if (row.dropdown) { row.dropdown = [...row.dropdown]; } return row; });
  //     this.cdr.detectChanges();
  //   }
  // }
  handleDropdownChange(field: string, children: string, event: any, dropdown, rowdata) {//Version Daniel
    if (this.onDpChangeEvento && this.onDpChangeEvento.closed === false) {
      const indexDatatable = this.data.findIndex(f => f === rowdata);
      this.metadataTableCopy = [...this.metadata];
      this.onDpChangeEvento.emit({ field, event, index: indexDatatable, rowdata });
      this.metadataTable = this.metadataTable.map(row => {
        if (row[this.key] === event[this.key]) {
          if (row.dropdown) {
            row.dropdown = [...row.dropdown];
          }
          return row;
        }
        return row;
      });
      this.cdr.detectChanges();
    }
  }

  handleInputChange(field: string, event: any, rowdata) {
    // // console.log("onInputChangeEvento", field, event, rowdata);
    if (this.onInputChangeEvento && this.onInputChangeEvento.closed === false) {
      const indexDatatable = this.data.findIndex(f => f === rowdata);
      this.onInputChangeEvento.emit({ field, event, index: indexDatatable, rowdata });
    }
  }

  handleCambioValoresOnDPChange(event: { field: string, event: any, index: any }) {
    // para setear valores en modo input disparado por un onchange de autocomplete
    if (event.field != null && event.index != -1 && event.event != undefined) {
      const field = event.field;
      const nuevoValor = event.event.value;
      const fila = this.data[event.index];
      if (fila) { fila[field] = nuevoValor; }
      this.cdr.detectChanges();
    }
  }

  reestablecerMetadata() {
    if (this.metadataTableCopy && this.metadataTableCopy.length > 0) {
      this.metadata = [...this.metadataTableCopy];
      delete this.metadataTableCopy;
    }
  }

  getTotal(data: any[], field: string): number {
    let total = 0
    data.forEach(r => {
      total += r[field] ? r[field] : 0
    })
    return total
  }


  generateStyle(data: any): { [key: string]: string } {
    let value = {}
    if (data) {
      if (data.align) { value['text-align'] = data.align }
      if (data.size) { value['font-size'] = data.size }
      if (data.justify) { value['justify-content'] = data.justify }
      if (data.background) { value['background-color'] = data.background }
      if (data.width) { value['width'] = data.width }
    }
    return value
  }

  getRowFooter(data: any[], field: string, type: string, datatype): string {
    let total = 0

    if (type === 'sum_misma_moneda') {
      const activos = data.filter(item => item.ESTADO_OBJ !== 'D');
      if (activos.length === 0) return this.formatNumber(0, datatype);

      // 1. Predefinimos las llaves según el tipo de campo una sola vez
      const esVenta = ['dope_preciounitvta', 'dope_preciototvta'].includes(field.toLowerCase());
      const keyMnd = esVenta ? 'nombremndvta' : 'nombremnd';
      const keyCodMnd = esVenta ? 'tipo_codmndventa' : 'tipo_codmnd';

      // 2. Extraemos monedas y verificamos diferencias en una sola línea
      const monedas = activos.map(item => {
        const val = item[keyMnd];
        return (val && typeof val === 'object') ? (val.value || item[keyCodMnd]) : (val || item[keyCodMnd]);
      }).filter(v => v); // Elimina null/undefined/empty

      const hayDiferenciaMoneda = new Set(monedas).size > 1;

      // 3. Sumatoria optimizada
      activos.forEach(r => {
        let valorFila: number;

        if (!hayDiferenciaMoneda) {
          valorFila = parseFloat(r[field]);
        } else {
          const configConversion = {
            columna: field,
            tipocambiocolumna: 'tipocambioventa',
            monedacolumna: (r[keyMnd] && typeof r[keyMnd] === 'object') ? keyMnd : keyCodMnd,
            tipovalor: null,
            comparartp: null
          };
          valorFila = this.convertirADolares(r, configConversion);
        }

        total += !isNaN(valorFila) ? valorFila : 0;
      });

      return this.formatNumber(total, datatype);
    }

    if (type == 'sum') {
      data.forEach(r => {
        if (r['ESTADO_OBJ'] !== 'D') {
          const valor = parseFloat(r[field]);
          total += !isNaN(valor) ? valor : 0;
        }
      });
      return this.formatNumber(total, datatype);
    }

    if (type == 'porcentaje' && Array.isArray(data)) {
      data.forEach(r => {
        if (r['ESTADO_OBJ'] !== 'D') {
          total += r[field] ? r[field] : 0
        }
      })

      // total = total / data.length
      total = total / data.filter(r => r['ESTADO_OBJ'] !== 'D').length;

      return this.formatNumber(total, datatype)
    }


    return total.toString()
  }

  export() {
    if (!this.dataTable || this.dataTable.length === 0) {
      console.warn('No hay datos para exportar.');
      return;
    }

    let nuevadata = []

    this.dataTable.forEach(row => {
      const newItem = {};

      this.metadata.forEach(e => {
        newItem[e.title.toUpperCase()] = row[e.field];
      });

      nuevadata.push(newItem);
    });

    const data = [{ data: nuevadata, cabeceras: [] }]
    const fileName = (this.exportFileName ?? 'Reportes Comercial') + '.xlsx';
    this.util.ExportarExcel(data, fileName, false);
  }

  clear(table: Table) {
    table.clear();
  }

  getDataRow(data: any, type: inputType = 'text'): any {
    switch (type) {
      case 'text':

        break;
      case 'dropdown':

        break;
      case 'decimal':

        return this.formatNumber(data, type)

        break;
      case 'int':
        return this.formatNumber(data, type)
        break;
      default:
        break;
    }

    return ''
  }

  formatNumber(value: any, type: string): string {

    if (type == 'percentage') {
      let valor = '0'

      if (isNaN(value)) {
        valor = '0 %'
      } else {
        valor = (value).toFixed(0) + ' %' //validar esta resta despues - 1
      }

      return valor
    }

    const numberValue = parseFloat(value);

    // Verifica si el valor es un número válido
    if (isNaN(numberValue)) return type === 'decimal' ? '0.00' : '0';

    // Define la cantidad de decimales según el tipo
    let decimalPlaces = type === 'decimal' ? 2 : (Math.floor(numberValue) === numberValue ? 0 : 1);

    // Usa toFixed para asegurarse de que el número tenga los decimales correctos
    const fixedNumber = numberValue.toFixed(decimalPlaces);

    // Usa una expresión regular para agregar separadores de miles
    const [integerPart, decimalPart] = fixedNumber.split('.');
    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // Devuelve el número con separadores de miles y los decimales
    return decimalPart ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart;
  }

  formatPorcentaje(value: any, decimales: number = 2): string {
    const numberValue = parseFloat(value);
    if (isNaN(numberValue)) return '0.00%';
    const fixedNumber = numberValue.toFixed(decimales);
    const [integerPart, decimalPart] = fixedNumber.split('.');
    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `${decimalPart ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart}%`;
  }

  validateOptionsTable() {

  }

  getFormattedPercentage(value: number): number {
    return Math.round(value); // o puedes usar parseInt(value);
  }

  selectedDate: Date;
  handleDateSelect(event: any) {
    this.selectedDate = event;
  }

  isDisabled() {
    this.selectedDate = null;
  }
  toggleState: boolean = true;


  imprimir(variable: any, inputType: string, vadsd: any) {
    if (inputType == 'dropdown') {
    }
  }
  imprimirInput(variable: any, inputType: string, field: any, disabled, toolTip) {
    // if (inputType == 'buttonPersonalizado' &&(toolTip =="Cambiar Estado" || toolTip =="Cambiar Nave")) {
    //   // console.log("field", field)
    //   // console.log("valor item2.field", variable)
    //   // console.log(" item2.disabled ", disabled)
    //   // console.log("toolTip", toolTip)
    // }
  }

  descargarArchivo(rowdata: any, index: number) {
    if (!rowdata.ovar_archivo) {
      console.error('No hay archivo disponible para descargar.');
      return;
    }
    const extension = rowdata.ovar_descrip.split('.').pop();
    const mimeType = this.getMimeType(extension);
    const fileName = `archivo_${rowdata.ovar_codigo}.${extension}`;

    const byteCharacters = atob(rowdata.ovar_archivo);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }


  getMimeType(extension: string): string {
    const mimeTypes: { [key: string]: string } = {
      'png': 'image/png',
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'gif': 'image/gif',
      'pdf': 'application/pdf',
      'txt': 'text/plain',
      'doc': 'application/msword',
      'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'xls': 'application/vnd.ms-excel',
      'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'zip': 'application/zip',
    };

    return mimeTypes[extension.toLowerCase()] || 'application/octet-stream';
  }

  mostrarDetalleTexto(row, field) {

    const detailColumn = this.metadataTable.find(item => item.field === field);
    const index = this.metadataTable.findIndex(item => item.field === field);

    if (index > 0) {
      const previousField = this.metadataTable[index - 1].field;
      const dataToSend = row[previousField];

      const conf: DynamicDialogConfig = {
        data: {
          rowData: dataToSend,
          isEditing: this.editing,
          rowEdit: this.rowEdit
        },
        header: detailColumn?.popupTitle || 'Observaciones',
        width: '90%',
        contentStyle: { overflow: 'auto' },
        baseZIndex: 10000,
        maximizable: true,
        closable: true
      };

      const ref = this.util.show(DialogDetalleComponent, this.ref, conf);

      ref.onClose.subscribe((updatedData) => {
        if (updatedData) {
          this.updateRowData(row, updatedData, previousField);

        }
      });
    } else {
      console.warn("No hay columna anterior disponible para mostrar el dialog detalle.");
    }
  }

  updateRowData(row: any, updatedData: any, field: string) {

    const index = this.dataTable.findIndex(item => item.id === row.id);
    if (index !== -1) {
      const updatedRow = { ...this.dataTable[index] };
      updatedRow[field] = updatedData !== undefined ? updatedData : null;
      for (const key in updatedRow) {
        if (updatedRow[key] === undefined) {
          updatedRow[key] = null;
        }
      }

      this.dataTable[index] = updatedRow;
      this.setValue(updatedRow);
    } else {
      console.warn("No se encontró el campo en dataTable.");
    }
  }

  actualizarMultiplicacion(fila: any, campoCambiado: string) {
    // // console.log("INFO DE RASULTADOS", fila, campoCambiado)
    //ARRAY DE COLUMNAS A MULTIPLICAR
    const columnasMultiplicar = this.metadataTable.filter(item => item.operacion === 'multiplicar').map(item => item.field);
    //ARRAY DE COLUMNAS A SUMAR
    const columnasSumar = this.metadataTable.filter(item => item.operacion === 'sumar').map(item => item.field);
    if (![...columnasMultiplicar, ...columnasSumar].includes(campoCambiado)) { return; }
    //POR SI MULTIPLICA
    let resultadoMultiplicacion = 1;
    columnasMultiplicar.forEach(field => {
      const valor = fila[field];
      if (valor == null || valor === '') {
        resultadoMultiplicacion = 0;
      } else {
        resultadoMultiplicacion *= valor;
      }
    });
    //POR SI SUMA
    let resultadoSuma = 0;
    columnasSumar.forEach(field => {
      if (fila[field] != null) {
        resultadoSuma += fila[field] || 0;
      }
    });
    //VERIFICA SI EXISTE COLUMNA decimalResultado
    const resultadoItem = this.metadataTable.find(item => item.inputType === 'decimalResultado');
    if (resultadoItem) {
      const campoResultado = resultadoItem.field;
      const control = this.group?.get(campoResultado);
      let resultadoFinal = columnasMultiplicar.length > 0 ? resultadoMultiplicacion : resultadoSuma;
      if (columnasMultiplicar.length > 0) {
        resultadoFinal = Math.round(resultadoFinal * 100) / 100;
      }
      fila[campoResultado] = resultadoFinal; // Actualiza el valor en la fila
      if (control) {
        control.setValue(resultadoFinal);
      } else {
        // // console.log(`El control para el campo "${campoResultado}" no existe en el formulario.`);
      }
    } else {
      // // console.log("No se encontró un campo con inputType 'decimalResultado'");
    }
  }

  // MEJORAR LOGICA
  actualizarMultiplicacion2(fila: any, campoCambiado: string) {
    // // console.log("INFO DE RASULTADOS", fila, campoCambiado)
    //ARRAY DE COLUMNAS A MULTIPLICAR
    const columnasMultiplicar = this.metadataTable.filter(item => item.operacion2 === 'multiplicar2').map(item => item.field);
    //ARRAY DE COLUMNAS A SUMAR
    const columnasSumar = this.metadataTable.filter(item => item.operacion2 === 'sumar2').map(item => item.field);
    if (![...columnasMultiplicar, ...columnasSumar].includes(campoCambiado)) { return; }
    //POR SI MULTIPLICA
    let resultadoMultiplicacion = 1;
    columnasMultiplicar.forEach(field => {
      const valor = fila[field];
      if (valor == null || valor === '') {
        resultadoMultiplicacion = 0;
      } else {
        resultadoMultiplicacion *= valor;
      }
    });
    //POR SI SUMA
    let resultadoSuma = 0;
    columnasSumar.forEach(field => {
      if (fila[field] != null) {
        resultadoSuma += fila[field] || 0;
      }
    });
    //VERIFICA SI EXISTE COLUMNA decimalResultado
    const resultadoItem = this.metadataTable.find(item => item.inputType === 'decimalResultado2');
    if (resultadoItem) {
      const campoResultado = resultadoItem.field;
      const control = this.group?.get(campoResultado);
      let resultadoFinal = columnasMultiplicar.length > 0 ? resultadoMultiplicacion : resultadoSuma;
      if (columnasMultiplicar.length > 0) {
        resultadoFinal = Math.round(resultadoFinal * 100) / 100;
      }
      fila[campoResultado] = resultadoFinal;
      if (control) {
        control.setValue(resultadoFinal);
      } else {
        // // console.log(`El control para el campo "${campoResultado}" no existe en el formulario.`);
      }
    } else {
      // // console.log("No se encontró un campo con inputType 'decimalResultado'");
    }
  }

  actualizarOperacion(fila: any, relacion: any[], campoCambiado: string) {
    const relaciones = relacion.filter(r =>
      r.columna === campoCambiado || r.multiplicador === campoCambiado
    );

    if (!relaciones.length) return;

    for (const r of relaciones) {
      const valor1 = fila[r.columna];
      const valor2 = fila[r.multiplicador];

      let resultado = 0;

      switch (r.operacion) {
        case 'multiplicar':
          if (valor1 != null && valor2 != null && valor1 !== '' && valor2 !== '') {
            resultado = valor1 * valor2;
            resultado = Math.round(resultado * 100) / 100;
          }
          break;

        case 'sumar':
          resultado = (valor1 || 0) + (valor2 || 0);
          break;
      }

      fila[r.resultado] = resultado;

      const control = this.group?.get(r.resultado);
      if (control) {
        control.setValue(resultado);
      }
    }
  }

  onRadioChange(event: any, field: string, rowdata): void {

  }

  onCheckboxChange(event: any, field: string, rowdata: any, i: any): void {

    const isChecked = event.checked;
    if (isChecked) {
      this.dataTable.forEach(row => {
        if (row !== rowdata) { row[field] = false; }
      });
    }
    rowdata[field] = isChecked;
    this.checkboxChange.emit({ rowIndex: i, isChecked: isChecked, rowdata: rowdata });
  }

  // -------------------------------------------------------------------------------------
  // Autor: Anthony Casas V.
  // Fecha Creación: 20/11/2024
  // -------------------------------------------------------------------------------------
  checkList: any[] = []
  // onChangeCheckList(event: Event, row: any): void {

  //   if (row.index === undefined || row.index === null || row.index === '') {
  //     // console.log('La fila necesita contener un atributo index valido.')
  //     return
  //   }

  //   if (event['checked']) {
  //     this.checkList.push(row)
  //   } else {
  //     this.checkList = this.checkList.filter(item => item.index !== row.index)
  //   }
  // }
  onChangeCheckList(event: any, row: any): void {

    if (row.index === undefined || row.index === null || row.index === '') {
      // // console.log('La fila necesita contener un atributo index valido.')
      return
    }

    if (event['checked']) {
      this.checkList.push(row)
    } else {
      this.checkList = this.checkList.filter(item => item.index !== row.index)
    }
  }

  resetCheckList(): void {
    this.checkList = []
  }

  saveOptionColumn() {
    const request = <transaccionOpcionesTablaRequest>{}

    request.usuario = this.storage.get('usuario')
    request.opcion = this.router.url
    request.tabla = this.id.toString().replace(/'/g, "")
    request.tab = ''

    let opcionesmetadata = []

    this.metadata?.forEach(r => {
      opcionesmetadata.push({ tabl_field: r.field })
    })

    request.opciones = opcionesmetadata
    request.tipo = 'I'

    this.rol.transaccionOpcionesTabla(request).subscribe(response => {
      if (response.datos.status === 200) {
        this.optionColumns = false;
        this.util.ShowMessage({ mensaje: 'Configuración asignada.' })
      }
    }), err => {
      const mensaje = err?.error?.meta?.mensaje || (err?.error?.errors ? Object.values(err.error.errors).flat().join(' | ') : 'Error');
      this.util.MessageDialog({ mensaje: mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
    }

  }

  cols: any[] = []
  _selectedColumns: any[] = []
  @Input() get selectedColumns(): any[] {
    return this._selectedColumns
  }

  set selectedColumns(val: any[]) {

    this._selectedColumns = this.cols.filter((col) =>
      val.some((v) => v.field === col.field)
    )

    this.metadata = this.metadataTable.filter(r =>
      this._selectedColumns.some(e => e.field === r.field)
    )

  }


  optionColumns: boolean
  showOptionColumns() {
    this.optionColumns = true
  }

  mainmetadata: newmetadate[] = []


  saveOptionColumns() {

    const request = <transaccionOpcionesTablaRequest>{}

    request.usuario = this.storage.get('usuario')
    request.opcion = this.router.url
    request.tabla = this.id.toString().replace(/'/g, "")
    request.tab = ''

    let opcionesmetadata = []

    this.metadata.forEach((r, i) => {
      opcionesmetadata.push({ tabl_field: r.field, tabl_index: i })
    })

    request.opciones = opcionesmetadata
    request.tipo = 'I'
    // console.log(request)
    this.rol.transaccionOpcionesTabla(request).subscribe(response => {
      if (response.datos.status === 200) {
        this.optionColumns = false;
        this.util.ShowMessage({ mensaje: 'Configuración asignada.' })
      }
    }), err => {
      const mensaje = err?.error?.meta?.mensaje || (err?.error?.errors ? Object.values(err.error.errors).flat().join(' | ') : 'Error');
      this.util.MessageDialog({ mensaje: mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
    }
  }

  reemplazarDataModoInput(data: any): void {
    const patchData: { [key: string]: any } = {};
    Object.keys(data).forEach(key => {
      patchData[key] = data[key];
    });
    this.group.patchValue(patchData);
    // console.log('Formulario actualizado:', this.group.value);
  }

  bool(value: any): boolean {
    if (value === 'true') { return true; }
    if (value === 'false') { return false; }
    return !!value;
  }

  ConfirmEditMasivo() {
    // let temporalDatatable = this.table._value
    // for (let index = 0; index < this.table._value.length; index++) {
    //   this.onRowEditSave(this.table._value[index], index)
    // }
    const clonedProduct = { ...this.table._value };
    for (let index = 0; index < this.table._value.length; index++) {
      // Clonamos el producto original para evitar modificar directamente
      this.onRowEditSave(clonedProduct[index], index);
    }
    // this.dataTable=temporalDatatable
    // // console.log("ConfirmEditMasivo dataTable", this.dataTable) // descomentar para PRUEBAS
    // // console.log("ConfirmEditMasivo data", this.data) // descomentar para PRUEBAS

  }

  EstadoEditarMasivo() {
    let temporalDatatable = this.table._value
    for (let index = 0; index < this.table._value.length; index++) {
      this.onRowEditInit(this.table._value[index])
    }

  }

  getSymbol(simbolo: any, item2?: any): string {
    // if (item2) // console.log("item2:", item2);
    if (!simbolo) return '';
    const symbolsMap: { [key: string]: string } = {
      '001': 'S/ ',
      'USD': 'S/ ',
      '002': '$ ',
      'SOL': '$ ',
      '003': '€ ',
      'EUR': '€ ',
      '004': '% ',
      'POR': '% ',
      '005': 'UN ',
      'UNI': 'UN ',
    };
    const sym = symbolsMap[simbolo] || '';
    // // console.log("simbolo:", simbolo);
    if (item2.field === 'ZONA II SOLES') { } // console.log("simbolo:", simbolo, item2); }
    return sym;
  }
  erroresValidacion: { [key: string]: string } = {};
  puedeValidar: { [key: number]: boolean } = {};
  verbtn: boolean = false;
  validarCampo(rowdata: any, item2: any): void {
    const campoActual = item2.field;
    if (this.editing === true) {
      this.campoActivo = campoActual;
    } else {
      this.campoActivo = null;
    }
    const valoresConvertidos: any = {};
    if (item2.relacionConversion) {

      item2.relacionConversion.forEach(cfg => {
        valoresConvertidos[cfg.columna] = this.convertirADolares(rowdata, cfg);
      });

      const costoDolares = valoresConvertidos['dope_preciounitcosto'];
      const profitFijoDolares = valoresConvertidos['profit_fijo']; // TARIFA
      const pfminimoDolares = valoresConvertidos['profitminimo'];
      const ventaDolares = isNaN(valoresConvertidos['dope_preciounitvta']) ? 0 : valoresConvertidos['dope_preciounitvta'];
      const costoPromedioDolares = valoresConvertidos['dope_preciounit_prom'];
      const vta_tariff = rowdata['venta_tarifa_original'];
      const rowId = rowdata.key || rowdata[this.key]; // usa el identificador de tu fila
      const errorKey = `${rowId}_${campoActual}`;
      const rowPrefix = `${rowId}_`;
      let subtotal = ventaDolares - Math.round(costoDolares);
      let nuevoProfit = Math.round(subtotal * 100) / 100;
      const tipo_tarifa = rowdata['tipo_codtar'];
      const esAdicional = rowdata['esadicional'];
      const codAutorizado = rowdata['cod_autorizado'];
      const monto_soli = rowdata['monto_solicitado'];
      const monto_orig = rowdata['monto_original'];
      const estado = rowdata['cons_codest'];
      Object.keys(this.erroresValidacion).forEach(key => {
        if (key.startsWith(rowPrefix)) {
          delete this.erroresValidacion[key];
        }
      });

      // logica para adicionales 
      if ((this.isnewRowAdded === true || esAdicional)) {
        let subtotal = ventaDolares - costoDolares;
        let nuevoProfit = Math.round(subtotal * 100) / 100;
        // // console.log("logica adicional")
        // // console.log("costo orig: ", monto_soli, "vta orig: ", monto_orig)
        // // console.log("costo: ", costoDolares, "vta: ", ventaDolares)
        if (nuevoProfit < 0) {
          if (codAutorizado == '002' && monto_soli == costoDolares && monto_orig == ventaDolares) {
            delete this.erroresValidacion[errorKey];
            if (rowdata['cons_codest'] == '006') {
              if (rowdata['cons_codest_orig'] == '002') {
                rowdata['cons_codest'] = '002';
                rowdata['cons_descest'] = 'PREFACTURADA';
              } else {
                rowdata['cons_codest'] = '001';
                rowdata['cons_descest'] = 'INGRESADA';
              }
            }
          } else {
            this.erroresValidacion[errorKey] = item2.textoAlerta[1];
            rowdata['cons_codest'] = '006';
            rowdata['cons_descest'] = 'POR AUTORIZAR';
          }
        } else {
          delete this.erroresValidacion[errorKey];
          if (rowdata['cons_codest'] == '006') {
            if (rowdata['cons_codest_orig'] == '002') {
              rowdata['cons_codest'] = '002';
              rowdata['cons_descest'] = 'PREFACTURADA';
            } else {
              rowdata['cons_codest'] = '001';
              rowdata['cons_descest'] = 'INGRESADA';
            }
          }
        }

        // lógica servicios con tarifa
      } else if ((estado === '001' || estado === '006' || estado === undefined) &&
        vta_tariff !== null && vta_tariff !== '' && vta_tariff !== undefined) {

        const convr = { columna: 'venta_tarifa_original', tipocambiocolumna: 'tipocambioventa', monedacolumna: 'cod_mnd_venta_tariff_original', tipovalor: null, comparartp: null };
        const vta_tariffDol = this.convertirADolares(rowdata, convr);

        // // console.log("logica serv con tarifa: vta tariif: ", vta_tariffDol, "monto_soli: ", ventaDolares)
        const mnd_tariff = rowdata['cod_mnd_venta_tariff_original'];
        const mnd_vta = rowdata['nombremndvta']?.value !== undefined ? rowdata['nombremndvta']?.value : (rowdata['tipo_codmndventa'] ?? null);
        let subtotal = ventaDolares - vta_tariffDol;
        let nuevoProfit = Math.round(subtotal * 100) / 100;

        if (nuevoProfit < 0) {
          if (codAutorizado == '002' && vta_tariffDol == ventaDolares) {
            delete this.erroresValidacion[errorKey];
            if (rowdata['cons_codest'] == '006') {
              if (rowdata['cons_codest_orig'] == '002') {
                rowdata['cons_codest'] = '002';
                rowdata['cons_descest'] = 'PREFACTURADA';
              } else {
                rowdata['cons_codest'] = '001';
                rowdata['cons_descest'] = 'INGRESADA';
              }
            }
          } else {
            this.erroresValidacion[errorKey] = item2.textoAlerta[0];
            rowdata['cons_codest'] = '006';
            rowdata['cons_descest'] = 'POR AUTORIZAR';
          }
        } else {
          delete this.erroresValidacion[errorKey];
          if (rowdata['cons_codest'] == '006') {
            if (rowdata['cons_codest_orig'] == '002') {
              rowdata['cons_codest'] = '002';
              rowdata['cons_descest'] = 'PREFACTURADA';
            } else {
              rowdata['cons_codest'] = '001';
              rowdata['cons_descest'] = 'INGRESADA';
            }
          }
        }

        // lógica servicios no tienen tarifa asociada ni son adicionales
      } else if (vta_tariff !== null && vta_tariff !== '' && vta_tariff !== undefined && (rowdata['dtar_codigo'] == null || rowdata['dtar_codigo'] == "")) {
        // // console.log("servicios sin tarifa")
        let subtotal = ventaDolares - costoDolares;
        let nuevoProfit = Math.round(subtotal * 100) / 100;
        if (nuevoProfit < 0) {
          if (codAutorizado == '002' && monto_soli == costoDolares && monto_orig == ventaDolares) {
            delete this.erroresValidacion[errorKey];
            if (rowdata['cons_codest'] == '006') {
              if (rowdata['cons_codest_orig'] == '002') {
                rowdata['cons_codest'] = '002';
                rowdata['cons_descest'] = 'PREFACTURADA';
              } else {
                rowdata['cons_codest'] = '001';
                rowdata['cons_descest'] = 'INGRESADA';
              }
            }
          } else {
            this.erroresValidacion[errorKey] = item2.textoAlerta[1];
            rowdata['cons_codest'] = '006';
            rowdata['cons_descest'] = 'POR AUTORIZAR';
          }
        } else {
          delete this.erroresValidacion[errorKey];
          if (rowdata['cons_codest'] == '006') {
            if (rowdata['cons_codest_orig'] == '002') {
              rowdata['cons_codest'] = '002';
              rowdata['cons_descest'] = 'PREFACTURADA';
            } else {
              rowdata['cons_codest'] = '001';
              rowdata['cons_descest'] = 'INGRESADA';
            }
          }
        }
      }
      rowdata['profit_local'] = Number(nuevoProfit);
    }
  }

  // versión hasta 6.1.64
  // validarCampo(rowdata: any, item2: any): void {
  //   const campoActual = item2.field;
  //   if (this.editing === true) {
  //     this.campoActivo = campoActual;
  //   } else {
  //     this.campoActivo = null;
  //   }
  //   const valoresConvertidos: any = {};
  //   if (item2.relacionConversion) {

  //     item2.relacionConversion.forEach(cfg => {
  //       valoresConvertidos[cfg.columna] = this.convertirADolares(rowdata, cfg);
  //     });

  //     const costoDolares = valoresConvertidos['dope_preciounitcosto'];
  //     const profitFijoDolares = valoresConvertidos['profit_fijo']; // TARIFA
  //     const pfminimoDolares = valoresConvertidos['profitminimo'];
  //     const ventaDolares = isNaN(valoresConvertidos['dope_preciounitvta']) ? 0 : valoresConvertidos['dope_preciounitvta'];
  //     const costoPromedioDolares = valoresConvertidos['dope_preciounit_prom'];

  //     // const nuevoProfit = Math.round((ventaDolares - Number(costoDolares.toFixed(2))) * 100) / 100;

  //     let subtotal;
  //     let nuevoProfit;

  //     const tipo_tarifa = rowdata['tipo_codtar'];
  //     const esadicional = rowdata['esadicional'];

  //     if (tipo_tarifa === '004') { //aduana
  //       subtotal = ventaDolares - (Math.round(costoDolares * 100) / 100);
  //       nuevoProfit = (subtotal * 100) / 100;
  //     } else if (esadicional == true) {
  //       subtotal = ventaDolares - costoDolares;
  //       nuevoProfit = Math.round(subtotal * 100) / 100;
  //     } else {
  //       subtotal = ventaDolares - Math.round(costoDolares);
  //       nuevoProfit = Math.round(subtotal * 100) / 100;
  //     }

  //     const rowId = rowdata.key || rowdata[this.key]; // usa el identificador de tu fila
  //     const errorKey = `${rowId}_${campoActual}`;

  //     const entidad = rowdata['cliente_tariff'];
  //     if (entidad == null || entidad === '' || entidad === undefined) {

  //       this.erroresValidacion = {}
  //       if (item2.tipoValidar === 'venta') {
  //         if (ventaDolares == 0) {
  //           // si es 0 no hace nada
  //           rowdata['profit_local'] = Number(nuevoProfit);
  //         } else {
  //           if (Number(nuevoProfit) < 0) {
  //             this.erroresValidacion[errorKey] = item2.textoAlerta[1];
  //             // this.acceptDisabled = true;
  //             rowdata['profit_local'] = Number(nuevoProfit); // RESTA VTA - COSTO
  //             rowdata['cons_codest'] = '006';
  //             rowdata['cons_descest'] = 'POR AUTORIZAR';
  //             // this.verbtn = true;
  //             this.verbtn = false;
  //           } else {
  //             if (Number(nuevoProfit) < Number(profitFijoDolares)) {
  //               if (Number(nuevoProfit) < pfminimoDolares) {
  //                 this.erroresValidacion[errorKey] = item2.textoAlerta[0];
  //                 // this.acceptDisabled = true;
  //                 rowdata['cons_codest'] = '006';
  //                 rowdata['cons_descest'] = 'POR AUTORIZAR';
  //                 rowdata['profit_local'] = Number(nuevoProfit);
  //               } else {
  //                 this.erroresValidacion[errorKey] = item2.textoAlerta[2];
  //                 // this.acceptDisabled = true;
  //                 rowdata['profit_local'] = Number(nuevoProfit);
  //                 rowdata['cons_codest'] = '006';
  //                 rowdata['cons_descest'] = 'POR AUTORIZAR';
  //               }
  //               // this.verbtn = true;
  //               this.verbtn = false;
  //             } else {
  //               delete this.erroresValidacion[errorKey];
  //               this.acceptDisabled = false;
  //               this.verbtn = false;
  //               if (rowdata['cons_codest'] == '006') {
  //                 rowdata['cons_codest'] = '001';
  //                 rowdata['cons_descest'] = 'INGRESADA';
  //               }
  //             }
  //           }
  //         }
  //       } else {
  //         // if (ventaDolares == 0) {
  //         //   // si es 0 no hace nada
  //         //   rowdata['profit_local'] = Number(nuevoProfit);
  //         // } else {
  //         if (Number(nuevoProfit) < 0) {
  //           this.erroresValidacion[errorKey] = item2.textoAlerta[2];
  //           // this.acceptDisabled = true;
  //           rowdata['profit_local'] = Number(nuevoProfit);
  //           rowdata['cons_codest'] = '006';
  //           rowdata['cons_descest'] = 'POR AUTORIZAR';
  //           this.verbtn = false;
  //         } else {
  //           if (Number(costoDolares) < Number(costoPromedioDolares)) {
  //             // this.erroresValidacion[errorKey] = item2.textoAlerta[0];
  //             // // this.acceptDisabled = true;
  //             // rowdata['profit_local'] = Number(nuevoProfit);
  //             // rowdata['cons_codest'] = '006';
  //             // rowdata['cons_descest'] = 'POR AUTORIZAR';
  //             // this.verbtn = true;

  //             // no hace nada cuando este caso se da
  //           } else {
  //             delete this.erroresValidacion[`${rowId}_dope_preciounitcosto`];
  //             delete this.erroresValidacion[`${rowId}_dope_preciounit_prom`];
  //             this.acceptDisabled = false;
  //             this.verbtn = false;
  //             // rowdata['cons_codest'] = '006';
  //             if (rowdata['cons_codest'] == '006') {
  //               rowdata['cons_codest'] = '001';
  //               rowdata['cons_descest'] = 'INGRESADA';
  //               this.erroresValidacion = {}
  //             }
  //           }
  //         }
  //         if (this.isnewRowAdded === true) {
  //           // if (Number(ventaDolares) <= 0 && Number(costoDolares) > 0) {
  //           if (Number(ventaDolares) < 0 && Number(costoDolares) > 0) {
  //             this.erroresValidacion[`${rowId}_dope_preciounitvta`] = item2.textoAlerta[1];
  //             this.erroresValidacion[`${rowId}_dope_preciototvta`] = item2.textoAlerta[1];
  //             // this.acceptDisabled = true;
  //             rowdata['cons_codest'] = '006';
  //             rowdata['profit_local'] = Number(nuevoProfit);
  //             rowdata['cons_descest'] = 'POR AUTORIZAR';
  //             this.verbtn = false;
  //           } else {
  //             if (Number(nuevoProfit) < 0) {
  //               this.erroresValidacion[errorKey] = item2.textoAlerta[2];
  //               // this.acceptDisabled = true;
  //               rowdata['cons_codest'] = '006';
  //               rowdata['profit_local'] = Number(nuevoProfit);
  //               rowdata['cons_descest'] = 'POR AUTORIZAR';
  //               this.verbtn = false;
  //             } else {
  //               delete this.erroresValidacion[`${rowId}_dope_preciounitvta`];
  //               delete this.erroresValidacion[`${rowId}_dope_preciototvta`];
  //               this.acceptDisabled = false;
  //               this.verbtn = false;
  //               if (rowdata['cons_codest'] == '006') {
  //                 rowdata['cons_codest'] = '001';
  //                 rowdata['cons_descest'] = 'INGRESADA';
  //               }
  //             }
  //           }
  //         }
  //         // }
  //       }

  //     }
  //   }
  // }

  convertirADolares(rowdata: any, config: any): number {
    let valor = Number(rowdata[config.columna]) ?? 0;
    if (config.tipovalor && rowdata[config.tipovalor] === '002' && config.comparartp) {
      const baseCol = config.comparartp;
      let base = Number(rowdata[baseCol]) ?? 0;
      const tipoCambioBase = Number(rowdata[config.tipocambiocolumna]) ?? 1;
      if (rowdata[config.monedacolumna] === '001') {
        base = base / tipoCambioBase;
      }
      valor = (base * valor) / 100;
    }
    const tipoCambio = Number(rowdata[config.tipocambiocolumna]) ?? 1;
    const mnd = rowdata[config.monedacolumna];
    if ((mnd?.value ?? mnd) === '001') {
      return (valor / tipoCambio);
    }
    else { return valor; }
  }

  isFieldBlocked(field: string): boolean {
    if (this.blockedColumns && this.blockedColumns.length > 0) {
      return this.blockedColumns.includes(field);
    }
    return this.editing
      ? this.blockedColumnsEdit.includes(field)
      : this.blockedColumnsAdd.includes(field);
  }
  handleDropdownChange2(field: string, children: string, event: any, dropdown, rowdata) {
    if (this.onDpChangeEvento && this.onDpChangeEvento.closed === false) {
      const indexDatatable = this.data.findIndex(f => f === rowdata);
      this.metadataTableCopy = [...this.metadata];
      if (indexDatatable !== -1) {
        this.metadataTable = this.metadataTable.map(row => {
          if (row[this.key] === event[this.key]) {
            if (row.dropdown) {
              row.dropdown = [...dropdown];

            }
            return row;
          }
          return row;
        });
        // this.data[indexDatatable][field] = event.value;
      }
      // console.log("onDpChangeEvento", field, event, indexDatatable, rowdata);
      this.onDpChangeEvento.emit({ field, event, index: indexDatatable, rowdata });
      this.cdr.detectChanges();
    }
  }

  resultadoOperacion
  generarOperacion(resultadoData: any) {
    this.resultadoOperacion = 120
  }

  getData() {
    return this.data
  }

  dialogMessage: boolean = false
  dialogConfig: dialogMessage = {
    message: "",
    size: "10px"
  }
  showMessage(message: string, size: string) {
    this.dialogMessage = true
    this.dialogConfig = {
      message: message,
      size: size
    }
  }

  public resetDatatable() {
    this.dataTable = [];
    this.data = [];
    this.clonedProducts = {};
  }

  resolveLockStatus(item2: any, row: any): boolean {
    const status = typeof item2.inputStatus === 'function' ? item2.inputStatus(row) : item2.inputStatus;
    return status === 'lock';
  }

  getDisabledSelectEdit(condicion: any, descripcion: any): boolean {
    if (condicion !== undefined || condicion != null) {
      if (descripcion !== undefined && descripcion == null) {
        if (String(condicion) === descripcion) {
          return true; // Deshabilitar si la condición es igual a la descripción
        } else {
          return false; // No deshabilitar si la condición no es igual a la descripción
        }
      } else {
        return condicion; // Usar el valor booleano de la condición directamente
      }
    } else {
      return false; // Por defecto, no deshabilitar
    }
  }

  checkLists: { [key: string]: any[] } = {}
  onChangeCheckList2(event: any, row: any, col: any): void {
    const key = col.field
    if (!this.checkLists[key]) {
      this.checkLists[key] = []
    }

    if (event.checked) {
      this.checkLists[key].push(row)
    } else {
      this.checkLists[key] = this.checkLists[key].filter(item => item.index !== row.index)
    }
  }

  public getFilaOriginal(product: any): any {
    return Object.values(this.clonedProducts).find(
      (x: any) => x.key === product.key
    );
  }

  imprimirDepuracion(variable: any, inputType: string, vadsd: any, dropdown: any[]) {
    // // console.log("imprimir", variable)
    // // console.log("inputType", inputType)
    // // console.log("vadsd", vadsd)
    // // // console.log("item2.dropdown", dropdown)
    // if (inputType == 'dropdown') {
    // }
  }

  actualizarValue(rowdata: any, field: string, newValue: any, dropdown: any[]) {
    const objetoCompleto = dropdown.find(opt => opt.value === newValue);
    rowdata[field] = objetoCompleto ?? newValue;

    // // console.log("Nuevo valor asignado:", rowdata[field]);
  }

  imprimirGlobal(dt: any, value: any) {
    // // console.log("dt", dt)
    // // console.log("value", value)
  }

  imprimirFiltros(dt: any, value: any) {
    // // console.log("dt", dt)
    // // console.log("value", value)
  }


  getOperadorExpresion(matchMode: string, fieldName: string): string {
    const mode = matchMode.toLowerCase();

    const isDate = fieldName.includes('fecha') || fieldName.includes('date');
    const isNumber = fieldName.includes('costo') || fieldName.includes('profit') || fieldName.includes('venta') || fieldName.includes('dias');

    if (isDate) {
      switch (mode) {
        case 'dateis': return '=';
        case 'dateisnot': return '!=';
        case 'datebefore': return '<';
        case 'dateafter': return '>';
      }
    }

    if (isNumber) {
      switch (mode) {
        case 'equals': return '=';
        case 'notequals': return '!=';
        case 'lt': return '<';
        case 'lte': return '<=';
        case 'gt': return '>';
        case 'gte': return '>=';
      }
    }

    switch (mode) {
      case 'startswith': return 'EMPIEZA CON';
      case 'contains': return 'CONTIENE';
      case 'notcontains': return 'NO CONTIENE';
      case 'endswith': return 'TERMINA CON';
      case 'equals': return '=';
      case 'notequals': return '!=';
      default: return mode.toUpperCase();
    }
  }

  generarCadenaFiltro(filtros: FiltroPrimeNG): string {
    const expresiones: string[] = [];

    const obtenerTitle = (field: string): string => {
      const meta = this.metadataTable.find(m => m.field === field);
      return meta ? meta.title : field;
    };

    // 1. Añadir el Filtro Global 
    // const filtroGlobalRaw = filtros['global'] as FilterMetadata;
    // if (filtroGlobalRaw && filtroGlobalRaw.value !== null && filtroGlobalRaw.value !== '') {
    //   const globalMode = (filtroGlobalRaw.matchMode || 'CONTAINS').toUpperCase();
    //   expresiones.push(`(FILTRO GLOBAL: ${globalMode} '${filtroGlobalRaw.value}')`);
    // }

    // 2. Procesar Filtros por Columna
    for (const columna in filtros) {
      if (columna !== 'global') {
        const condiciones = filtros[columna] as FilterMetadata[];

        if (Array.isArray(condiciones)) {

          const titleColumna = obtenerTitle(columna);
          const filtrosColumnaActivos = condiciones
            // Filtramos solo las condiciones que tienen un valor asignado
            .filter(condicion => condicion.value !== null && condicion.value !== '')
            .map(filtro => {
              const operador = this.getOperadorExpresion(filtro.matchMode, columna);
              let valorRepresentacion = filtro.value;

              if (valorRepresentacion instanceof Date) {
                const fechaFormateada = this.util.formatearfecha(valorRepresentacion, 'yyyy-mm-dd');
                valorRepresentacion = `'${fechaFormateada}'`;
              }
              else if (typeof valorRepresentacion === 'string') {
                valorRepresentacion = `'${valorRepresentacion}'`;
              } else if (Array.isArray(valorRepresentacion)) {
                // Manejar filtros de selección múltiple (multiselect) de PrimeNG
                valorRepresentacion = `(${valorRepresentacion.map(v => `'${v}'`).join(' O ')})`;
                // Para el multiselect, el operador es implícitamente "IN" (IGUAL A uno de)
                return `<b>[${titleColumna}]</b> ES IGUAL A UNO DE ${valorRepresentacion}`;
              }

              // Formato final: [Columna] OPERADOR Valor
              return `<b>[${titleColumna}]</b> ${operador} ${valorRepresentacion}`;
            });

          if (filtrosColumnaActivos.length > 0) {
            // Unimos las múltiples condiciones de una columna con su operador interno (usamos el 'operator' del JSON)
            const operadorInterno = (condiciones[0].operator || 'and').toUpperCase();
            expresiones.push(`(${filtrosColumnaActivos.join(` ${operadorInterno} `)})`);
          }
        }
      }
    }

    // 3. Concatenar todas las expresiones con " Y " (AND)
    if (expresiones.length > 0) {
      return expresiones.join(" Y ");
    } else {
      return "";
    }
  }

  notificarCambioFiltros(): void {
    const filtrosActuales = this.table.filters;
    this.cadenaFiltrosConsolidada.set(this.generarCadenaFiltro(filtrosActuales));

    // // console.log("--- 🔎 Cadena de Filtro Consolidada Actualizada 📝 ---");
    // // console.log(this.cadenaFiltrosConsolidada());
    // // console.log(this.table)
    // // console.log("-------------------------------------------------------");
  }

  onTableFilter(event: any): void {
    const filters = event.filters;
    let customFilterApplied = false;

    for (const field in filters) {
      if (filters.hasOwnProperty(field)) {
        const filterData = filters[field];
        const meta = this.metadataTable.find(m => m.field === field);

        if (meta && meta.inputType === 'autocomplete') {
          const condition = Array.isArray(filterData) ? filterData[0] : filterData;

          if (condition && condition.value !== null && condition.value.trim() !== '') {
            customFilterApplied = true;
          }
        }
      }
    }

    this.notificarCambioFiltros();
  }

  public getDataFiltrada(): any[] {
    return this.table.filteredValue ?? this.table.value;
  }

  public obtenerEstado(estado: string | undefined | null): string {
    return (estado === 'I' || estado === 'D' || estado === 'A') ? estado : 'U';
  }
  public cancelarEdicionActiva() {
    if (!this.table?.editingRowKeys || !this.data) return;

    const keysInEdit = Object.keys(this.table.editingRowKeys);

    if (keysInEdit.length > 0) {
      keysInEdit.forEach(key => {
        if (this.table.editingRowKeys[key]) {
          const index = this.data.findIndex(item => item[this.key]?.toString() === key);

          if (index !== -1) {
            const product = this.data[index];
            if (product) {
              this.onRowEditCancel(product, index);
            }
          }
        }
      });
    }
  }

  public aceptarEdicionActiva() {
    if (!this.table?.editingRowKeys || !this.data) return;

    const keysInEdit = Object.keys(this.table.editingRowKeys);

    if (keysInEdit.length > 0) {
      keysInEdit.forEach(key => {
        if (this.table.editingRowKeys[key]) {
          const index = this.data.findIndex(item => item[this.key]?.toString() === key);

          if (index !== -1) {
            const product = this.data[index];
            if (product) {
              this.onRowEditSave(product, index);
            }
          }
        }
      });
    }
  }

  triggerActualizarEstado(row: any, actualizarEstado: boolean = false) {
    if (!actualizarEstado) return;

    if (!row.ESTADO_OBJ || row.ESTADO_OBJ === 'NA' || row.ESTADO_OBJ === '') {
      row.ESTADO_OBJ = 'U';
    }
  }

  // public getFirstEditingRow(): any | null {
  //   const editingKey = Object.keys(this.table?.editingRowKeys || {})
  //     .find(key => this.table.editingRowKeys[key] === true);

  //   return editingKey
  //     ? this.data?.find(row => row[this.key]?.toString() === editingKey)
  //     : null;
  // }

  public getFirstEditingRow(): any | null {
    const editingKey = Object.keys(this.table?.editingRowKeys || {})
      .find(key => this.table.editingRowKeys[key] === true);

    if (!editingKey) return null;

    const index = this.data?.findIndex(row => row[this.key]?.toString() === editingKey) ?? -1;
    const row = index !== -1 ? this.data?.[index] : null;

    if (row) {
      row.__editIndex = index;
    }

    return row;
  }

}

class dialogMessage {
  message: string = ""
  size: string = "80vw"
}


//////////////////Esto es para lo del texto en observacion////////////////////
interface DialogMessage {
  message: string;
  size: string;
}


export class EditorDialogDemoComponent {
  dialogMessage: boolean = false;

  dialogConfig: DialogMessage = {
    message: '',
    size: '50vw'
  };

  showMessage(message: string, size: string) {
    this.dialogConfig.message = message;
    this.dialogConfig.size = size;
    this.dialogMessage = true;
  }
}

interface FiltroPrimeNG {
  [key: string]: FilterMetadata | FilterMetadata[];
  global?: { value: any, matchMode: string };
}
